export default __webpack_public_path__ + "static/media/table.453e5686.svg";